export default __webpack_public_path__ + "static/media/ic_rotate_right.3fc153bb.svg";